import React from "react";
import { Card, DataTable, OneLineShowMore, Table } from "@sscs/ui";
import { REPORT_PAGES_ROUTES, ROOT_FILE_PATH } from "../../../constants";
import { expandedRowsUpdated, focusedRowUpdated, selectExpandedRow, selectFocusedRow, } from "../../../store/secretsSlice";
import { ExpandedRowDetails, SecretLiveness } from "../../../ui";
import { AuditCell, CryptographyReferences, EndpointsTable, IssuesList, PolicyAudit, SecretExposure, StatusLabel, } from "../../common";
import { useReportDispatch, useReportSelector } from "../../hooks";
import SampleSummary from "../SampleSummary/SampleSummary";
import styles from "./secretsTable.module.scss";
const SecretDetails = ({ rowIndex, secret, scanTime, endpointLabelHighlight, }) => {
    var _a, _b;
    const dispatch = useReportDispatch();
    const expanded = useReportSelector((state) => selectExpandedRow(state, secret.id));
    const focusedRow = useReportSelector(selectFocusedRow);
    return (React.createElement(DataTable.ExpandedRow, { id: `secrets-expand-row-${rowIndex}`, key: secret.id, expanded: expanded, onChange: (isExpanded) => dispatch(expandedRowsUpdated({
            id: secret.id,
            expand: isExpanded,
        })), focused: focusedRow === secret.id, onClick: () => dispatch(focusedRowUpdated(secret.id)) },
        React.createElement(DataTable.ExpandedRow.Summary, null,
            React.createElement(Table.Cell, null,
                React.createElement(StatusLabel, { level: secret.policy.level, status: secret.policy.status })),
            React.createElement(Table.Cell, null,
                React.createElement(SecretLiveness, { liveness: secret.liveness, exposed: secret.exposed })),
            React.createElement(Table.Cell, null,
                React.createElement(SecretExposure, { exposed: secret.exposed, timestamp: secret.timestamp })),
            React.createElement(Table.Cell, null,
                React.createElement("b", null, secret.service)),
            React.createElement(Table.Cell, null,
                React.createElement(OneLineShowMore, { value: secret.secret
                        ? secret.secret
                        : ((_a = secret.file_basic.path) !== null && _a !== void 0 ? _a : ROOT_FILE_PATH) }),
                React.createElement("div", { className: styles["secondary-text"] }, Number(secret.line_number) !== -1
                    ? `Line: ${secret.line_number.toString()}`
                    : secret.file_offset !== 0
                        ? `Secret starts at file offset: 0x${secret.file_offset.toString(16)}`
                        : "The entire extracted file is a secret")),
            React.createElement(Table.Cell, null, secret.canary ? "Yes" : "No"),
            React.createElement(Table.Cell, null,
                React.createElement(AuditCell, { audit: secret.audit }))),
        React.createElement(DataTable.ExpandedRow.Details, null,
            React.createElement(ExpandedRowDetails, null,
                React.createElement(ExpandedRowDetails.Aside, null,
                    React.createElement(SampleSummary, { secretId: secret.id, componentId: secret.component_id, file: secret.file_basic }),
                    secret.audit.present ? React.createElement(PolicyAudit, { audit: secret.audit }) : null,
                    React.createElement(IssuesList, { violations: [secret.policy.id], to: REPORT_PAGES_ROUTES.ISSUES_ROUTE })),
                React.createElement(ExpandedRowDetails.Main, null,
                    React.createElement(Card.Card, null,
                        React.createElement(Card.Title, null, secret.service),
                        React.createElement(Card.Content, null, (_b = secret.service_description) !== null && _b !== void 0 ? _b : "No description available")),
                    secret.cryptography.length ? (React.createElement(CryptographyReferences, { CBOMRoute: REPORT_PAGES_ROUTES.CBOM_ROUTE, references: secret.cryptography })) : (React.createElement(EndpointsTable, { endpoints: secret.endpoints, endpointLabelHighlight: endpointLabelHighlight, liveness: secret.liveness, scanTime: scanTime })))))));
};
export default SecretDetails;
//# sourceMappingURL=SecretDetails.js.map